import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Image } from "../components/media";
import { LinkChildren } from "../components/button";

import { logingOut } from "../actions/authActions";

function ClientTopBar(props) {
  const userName = props.auth?.user?.name || "Cliente SCargo";
  return (
    <div className="topbar">
      <div className="row align-items-center">
        <div className="col-md-12 align-self-center">
          <div className="togglebar">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <div className="menubar">
                  <a className="menu-hamburger" href="#!">
                    <Image
                      src="svg-icon/collapse.svg"
                      className="img-fluid menu-hamburger-collapse"
                    />
                    <Image
                      src="svg-icon/close.svg"
                      className="img-fluid menu-hamburger-close"
                    />
                  </a>
                </div>
              </li>
              <li className="list-inline-item">
                <div className="searchbar">
                  {/* <form>
                    <div className="input-group">
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Buscar"
                        aria-label="Buscar"
                        aria-describedby="button-addon2"
                      />
                      <div className="input-group-append">
                        <button
                          className="btn"
                          type="button"
                          id="button-addon2"
                        >
                          <Image src="svg-icon/search.svg" />
                        </button>
                      </div>
                    </div>
                  </form> */}
                </div>
              </li>
            </ul>
          </div>
          <div className="infobar">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <div className="notifybar">
                  <div className="dropdown">
                    <a
                      className="dropdown-toggle infobar-icon"
                      href="#!"
                      role="button"
                      id="notoficationlink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <Image src="svg-icon/notifications.svg" />
                      <span className="live-icon"></span>
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-right"
                      aria-labelledby="notoficationlink"
                    >
                      <div className="notification-dropdown-title">
                        <h4>Notificaciones</h4>
                      </div>
                      <ul className="list-unstyled">
                        {/* <li className="media dropdown-item">
                          <span className="action-icon badge badge-primary-inverse">
                            <i className="feather icon-dollar-sign"></i>
                          </span>
                          <div className="media-body">
                            <h5 className="action-title">
                              Nuevo producto recibido
                            </h5>
                            <p>
                              <span className="timing">Today, 10:45 AM</span>
                            </p>
                          </div>
                        </li>
                        <li className="media dropdown-item">
                          <span className="action-icon badge badge-success-inverse">
                            <i className="feather icon-file"></i>
                          </span>
                          <div className="media-body">
                            <h5 className="action-title">
                              Paquete completado y listo para envio
                            </h5>
                            <p>
                              <span className="timing">
                                Yesterday, 01:40 PM
                              </span>
                            </p>
                          </div>
                        </li>
                        <li className="media dropdown-item">
                          <span className="action-icon badge badge-danger-inverse">
                            <i className="feather icon-eye"></i>
                          </span>
                          <div className="media-body">
                            <h5 className="action-title">
                              Un paquete ha llegado a la ciudad
                            </h5>
                            <p>
                              <span className="timing">
                                3 Sep 2019, 05:22 PM
                              </span>
                            </p>
                          </div>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>

              <li className="list-inline-item">
                <div className="profilebar">
                  <div className="dropdown">
                    <a
                      className="dropdown-toggle"
                      href="#!"
                      role="button"
                      id="profilelink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <Image src="users/profile.svg" />

                      <span className="feather icon-chevron-down live-icon"></span>
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-right"
                      aria-labelledby="profilelink"
                    >
                      <div className="dropdown-item">
                        <div className="profilename">
                          <h5>{userName}</h5>
                        </div>
                      </div>
                      <div className="userbox">
                        <ul className="list-unstyled mb-0">
                          <li className="media dropdown-item">
                            <LinkChildren
                              extraClass="profile-icon"
                              href="/dashboard/account"
                            >
                              <Image src="svg-icon/user.svg" />
                              Mi Cuenta
                            </LinkChildren>
                          </li>
                          <li className="media dropdown-item">
                            <a
                              href="#!"
                              className="profile-icon"
                              onClick={() => {
                                logingOut();
                              }}
                            >
                              <Image src="svg-icon/logout.svg" />
                              Cerrar sesion
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

// @ts-ignore
ClientTopBar.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(ClientTopBar);
